import { Table } from '@/components/maintenance_type/table'

export const MaintenanceTypes = () => {
  return (
    <>
      <Table pageSize={20} createable onIndex />
    </>
  )
}
